module.exports = {
	"_args": [
		[
			"elliptic@3.1.0",
			"C:\\Users\\nktpa\\Desktop\\atlantida-solutions"
		]
	],
	"_from": "elliptic@3.1.0",
	"_id": "elliptic@3.1.0",
	"_inBundle": false,
	"_integrity": "sha1-whaC73YnabVqdCAWCRBdoR1fYMw=",
	"_location": "/elliptic",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "elliptic@3.1.0",
		"name": "elliptic",
		"escapedName": "elliptic",
		"rawSpec": "3.1.0",
		"saveSpec": null,
		"fetchSpec": "3.1.0"
	},
	"_requiredBy": [
		"/eth-lightwallet"
	],
	"_resolved": "https://registry.npmjs.org/elliptic/-/elliptic-3.1.0.tgz",
	"_spec": "3.1.0",
	"_where": "C:\\Users\\nktpa\\Desktop\\atlantida-solutions",
	"author": {
		"name": "Fedor Indutny",
		"email": "fedor@indutny.com"
	},
	"bugs": {
		"url": "https://github.com/indutny/elliptic/issues"
	},
	"dependencies": {
		"bn.js": "^2.0.3",
		"brorand": "^1.0.1",
		"hash.js": "^1.0.0",
		"inherits": "^2.0.1"
	},
	"description": "EC cryptography",
	"devDependencies": {
		"browserify": "^3.44.2",
		"jscs": "^1.11.3",
		"jshint": "^2.6.0",
		"mocha": "^2.1.0",
		"uglify-js": "^2.4.13"
	},
	"homepage": "https://github.com/indutny/elliptic",
	"keywords": [
		"EC",
		"Elliptic",
		"curve",
		"Cryptography"
	],
	"license": "MIT",
	"main": "lib/elliptic.js",
	"name": "elliptic",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/indutny/elliptic.git"
	},
	"scripts": {
		"test": "make lint && mocha --reporter=spec test/*-test.js"
	},
	"version": "3.1.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/elliptic/package.json
// module id = 1211
// module chunks = 0